import { get } from "../methods";
function getIndustryFields_default() {
  return get({
    url: `api/industry/fields`
  });
}
export {
  getIndustryFields_default as default
};
